








































import Vue from "vue";
import { Form } from "element-ui";
import { mapActions } from "vuex";

export default Vue.extend({
  name: "Invite",
  props: {
    tenantId: String
  },
  data() {
    return {
      dialog: false,
      roleOptions: [
        {
          value: "TEN_ADMIN",
          name: "租户管理员"
        },
        {
          value: "TEN_REGULAR",
          name: "普通用户"
        }
      ],
      form: {
        userName: "",
        userId: "",
        role: ""
      },
      rules: {
        role: [{ required: true, message: "请选择角色", trigger: "blur" }]
      }
    };
  },
  methods: {
    ...mapActions("SpaceMembers", ["updataUserRole"]),
    show(data: any) {
      this.form = Object.assign(
        {},
        { userName: data.userName, userId: data.userId, role: data.role }
      );
      this.dialog = true;
    },
    quit() {
      this.form = (this as any).$options.data().form;
      (this.$refs.form as Form).resetFields();
      this.dialog = false;
    },
    submit() {
      (this.$refs.form as any).validate((valid: any) => {
        if (valid) {
          this.updataUserRole({
            tenantId: this.tenantId,
            userId: this.form.userId,
            role: this.form.role
          });
          this.quit();
        }
      });
    }
  }
});
